import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

import {
  ChevronUp,
  // Eye,
  // RotateCcw,
  // Trash2,
} from "feather-icons-react/build/IconComponents";
import { Link } from "react-router-dom";

import Table from "../../../../../core/pagination/datatable";
import { BASE_CRM_URL } from "../../../../components/config/config";
import { Spin } from "antd";
import dayjs from "dayjs";
// import { Download } from "react-feather";
// import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Payments = () => {
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );
  //   //   const route = all_routes;

  const columns = [
    {
      title: "Payments",
      dataIndex: "id",
      key: "id",
      render: (id) => `PY-${id}`,
    },

    {
      title: "Invoice",
      key: "invoice",
      render: (_, record) => {
        const invoiceNo = `${record.InvoicePrefix || ""}${
          record.InvoiceNumber || ""
        }`;

        return (
          <span title={invoiceNo}>
            <i className="fa-regular fa-file-lines me-2 text-primary"></i>
            {invoiceNo.length > 15
              ? `${invoiceNo.substring(0, 15)}...`
              : invoiceNo}
          </span>
        );
      },
    },

    // {
    //   title: "Mode",
    //   dataIndex: "PaymentModeName",
    //   key: "PaymentModeName",
    //   render: (text) => text || "N/A",
    //   sorter: (a, b) =>
    //     (a.PaymentModeName || "").localeCompare(b.PaymentModeName || ""),
    // },
    {
      title: "Mode",
      dataIndex: "PaymentModeName",
      key: "PaymentModeName",
      render: (text) => {
        const mode = (text || "").toLowerCase();

        let badgeClass = "badge bg-soft-secondary";

        if (mode === "upi") {
          badgeClass = "badge bg-soft-info";
        } else if (mode === "cash") {
          badgeClass = "badge bg-soft-success";
        } else if (mode === "card") {
          badgeClass = "badge bg-soft-primary";
        } else if (mode === "cheque") {
          badgeClass = "badge bg-soft-warning text-dark";
        }

        return <span className={badgeClass}>{text || "N/A"}</span>;
      },
      sorter: (a, b) =>
        (a.PaymentModeName || "").localeCompare(b.PaymentModeName || ""),
    },

    {
      title: "Transaction ID",
      dataIndex: "transactionid",
      key: "transactionid",
      render: (text) => {
        const value = text || "N/A";

        return (
          <span title={value}>
            {value.length > 15 ? `${value.substring(0, 15)}...` : value}
          </span>
        );
      },
      sorter: (a, b) =>
        (a.transactionid || "").localeCompare(b.transactionid || ""),
    },

    {
      title: "Customer",
      dataIndex: "ClientName",
      key: "ClientName",
      render: (text) => {
        const value = text || "N/A";

        return (
          <span title={value}>
            {value.length > 15 ? `${value.substring(0, 15)}...` : value}
          </span>
        );
      },
      sorter: (a, b) => (a.ClientName || "").localeCompare(b.ClientName || ""),
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => {
        const value = text ?? "0.00";

        return (
          <span className="text-success">
            {" "}
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {value}
          </span>
        );
      },
      sorter: (a, b) => Number(a.amount || 0) - Number(b.amount || 0),
    },

    {
      title: "Date",
      dataIndex: "date",

      render: (date) => {
        const created = dayjs(date);

        return (
          <div>
            <i className="fa-regular fa-calendar me-2 text-info"></i>
            {created.isValid() ? created.format("DD-MM-YYYY") : "-"}
          </div>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: () => (
        <div className="action-table-data">
          <div className="edit-delete-action ">
            <Link
              title="view"
              // to={`/crm/viewpayments/${record.id}`}
              to="/crm/viewpayments"
              className="btn"
            >
              {/* <Eye className="info-img" /> */}
              <i className="ti ti-eye text-info"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [paymentsData, setPaymentsData] = useState([]);
  const [paymentsCount, SetpaymentCounts] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);

  console.log(paymentsCount, "pppppppppppp");

  const [loading, setLoading] = useState(false);
  console.log(paymentsData, paymentsCount, loading);

  const getPayments = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${BASE_CRM_URL}payments/GetPayments`);
      const data = await response.json();

      if (data.Status) {
        setPaymentsData(data.ResultData || []);
      } else {
        setPaymentsData([]);
      }
    } catch (error) {
      console.error("Error fetching payments list", error);
      setPaymentsData([]);
    } finally {
      setLoading(false);
    }
  };
  const getPaymentsCount = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}payments/GetPaymentCounts`);

      const data = await response.json();

      if (data.Status) {
        SetpaymentCounts(data.ResultData?.[0] || {});
      } else {
        SetpaymentCounts([]);
      }
    } catch (error) {
      console.error("Error fetching payments count list", error);
      SetpaymentCounts([]);
    }
  };

  useEffect(() => {
    getPayments();
    getPaymentsCount();
  }, []);

  const exportPaymentPDF = () => {
    try {
      setExportLoading(true);
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Payment",
        "Invoice",
        "Mode",
        "Transaction ID",
        "Customer",
        "Amount",
        "Date",
      ];
      // PDF rows
      const rows = paymentsData.map((payment) => {
        const invoiceNo = `${payment.InvoicePrefix || ""}${payment.InvoiceNumber || ""}`;
        return [
          payment.id ? `PY-${payment.id}` : "N/A",
          invoiceNo || "N/A",
          payment.PaymentModeName || "N/A",
          payment.transactionid || "N/A",
          payment.ClientName || "N/A",
          payment.amount !== null && payment.amount !== undefined
            ? Number(payment.amount).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00",
          payment.date
            ? dayjs(payment.date).isValid()
              ? dayjs(payment.date).format("DD-MM-YYYY")
              : "-"
            : "-",
        ];
      });
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text("Payments Report", 148, 12, { align: "center" });
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated On: ${generatedOn}`, 291, 12, { align: "right" });
      doc.setFontSize(9);
      const totalAmount = paymentsData.reduce(
        (total, payment) => total + Number(payment.amount || 0),
        0,
      );
      doc.text(`Total Payments: ${paymentsData.length}`, 5, 12);
      doc.text(
        `Total Amount: Rs. ${totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        5,
        17,
      );
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: 23,
        margin: { top: 23, bottom: 15, left: 5, right: 5 },
        theme: "grid",
        tableWidth: "auto",
        styles: {
          fontSize: 7,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },
        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
        },
        columnStyles: {
          0: { cellWidth: 20, halign: "center" },
          1: { cellWidth: 25 },
          2: { cellWidth: 22, halign: "center" },
          3: { cellWidth: 38 },
          4: { cellWidth: "auto" },
          5: { cellWidth: 28, halign: "right" },
          6: { cellWidth: 25, halign: "center" },
        },
        showHead: "everyPage",
        didDrawPage: () => {
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text(
            "Generated by Pereco | Powered by perennialcode",
            pageWidth / 2,
            pageHeight - 7,
            { align: "center" },
          );
        },
      });
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        // const pageWidth = doc.internal.pageSize.getWidth();
        // const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        // doc.text(`Page ${i} of ${totalPages}`, pageWidth - 5, pageHeight - 7, {
        //   align: "right",
        // });
        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }
      doc.save("Payments.pdf");
    } catch (error) {
      console.error("Payments PDF export error:", error);
      alert("Failed to generate Payments PDF file");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPaymentExcel = async () => {
    try {
      setExportLoading(true);
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Payments");
      worksheet.columns = [
        { header: "Payment", key: "payment", width: 15 },
        { header: "Invoice", key: "invoice", width: 22 },
        { header: "Mode", key: "paymentMode", width: 18 },
        { header: "Transaction ID", key: "transactionId", width: 25 },
        { header: "Customer", key: "customer", width: 30 },
        { header: "Amount", key: "amount", width: 18 },
        { header: "Date", key: "date", width: 18 },
      ];
      paymentsData.forEach((payment) => {
        const invoiceNo = `${payment.InvoicePrefix || ""}${payment.InvoiceNumber || ""}`;
        worksheet.addRow({
          payment: payment.id ? `PY-${payment.id}` : "N/A",
          invoice: invoiceNo || "N/A",
          paymentMode: payment.PaymentModeName || "N/A",
          transactionId: payment.transactionid || "N/A",
          customer: payment.ClientName || "N/A",
          amount:
            payment.amount !== null && payment.amount !== undefined
              ? Number(payment.amount)
              : 0,
          date: payment.date
            ? dayjs(payment.date).isValid()
              ? dayjs(payment.date).format("DD-MM-YYYY")
              : ""
            : "",
        });
      });
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      headerRow.height = 24;
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      worksheet.getColumn("amount").numFmt = "#,##0.00";
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", wrapText: true };
        });
        if (rowNumber > 1) {
          row.height = 22;
        }
      });
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";
      worksheet.printTitlesRow = "1:1";
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };
      worksheet.views = [{ state: "frozen", ySplit: 1 }];
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Payments.xlsx");
    } catch (error) {
      console.error("Payments Excel export error:", error);
      alert("Failed to generate Payments Excel file");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/Dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Payments
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Payments here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={exportPaymentPDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={exportPaymentExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            {/* <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li> */}
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          {/* <div className="page-btn">
            <Link to="#" className="btn btn-primary">
                         <i className="ti ti-circle-plus me-1"></i>
                       New Payments
                       </Link>
          </div> */}
        </div>
        <div className="row g-3">
          {/* Draft */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {paymentsCount?.TotalPayments}
                  </h4>
                  <p className="mb-0  fw-semibold">Total</p>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex justify-content-center align-items-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-money-check-dollar text-primary fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Sent */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {" "}
                    ₹{" "}
                    {Number(paymentsCount?.AmountReceived || 0).toLocaleString(
                      "en-IN",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}
                  </h4>
                  <p className="mb-0  fw-semibold">Amount</p>
                </div>

                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex justify-content-center align-items-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-sack-dollar text-success fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Expired */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {paymentsCount?.TodaysPayments}
                  </h4>
                  <p className="mb-0  fw-semibold">Today </p>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex justify-content-center align-items-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-calendar-day text-info fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Declined */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div className="card flex-fill  shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {" "}
                    ₹{" "}
                    {Number(paymentsCount?.TodaysAmount || 0).toLocaleString(
                      "en-IN",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}
                  </h4>
                  <p className="mb-0  fw-semibold">TodayAmount</p>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex justify-content-center align-items-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-hourglass-half text-warning fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>

            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                {/* <Link
                  to="#"
                  className="btn btn-white btn-md d-inline-flex align-items-center"
                 
                >
                  <i className="ti ti-filter me-1"></i>
                </Link> */}
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={paymentsData} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter className="pt-3" />
      </div>
    </div>
  );
};

export default Payments;
